import { render, staticRenderFns } from "./ModalEtapas.vue?vue&type=template&id=5daca8b1&"
import script from "./ModalEtapas.vue?vue&type=script&lang=js&"
export * from "./ModalEtapas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports